"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newRoutes = void 0;
exports.newRoutes = {
    '/giveaway-history': {
        url: '/giveaway-history',
        modules: [],
    },
    '/giveaway-history/:id': {
        url: '/giveaway-history/:id',
        modules: [],
    },
    '/audience-targeting': {
        url: '/audience-targeting',
        modules: [],
    },
};
